import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';

interface Props {
  channelId?: number;
  channelSlug?: string;
}

export function useChannel({
  channelId,
  channelSlug,
}: Props): MBAPI.ChannelQuery_channel | undefined {
  const { data } = useQuery<MBAPI.ChannelQuery, MBAPI.ChannelQueryVariables>(
    Queries.channel.getChannel,
    {
      variables: { id: channelId, slug: channelSlug },
      skip: isNil(channelId) && isNil(channelSlug),
    },
  );

  return data?.channel;
}
